module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"description":"En relançant la recherche avec ces critères, plus de résultats peuvent être trouvés. Voulez-vous relancer la recherche ?"},"en":{"description":"By repeating the search with these criteria, more results can be found. Would you like to start the search again?"}}')
  delete Component.options._Ctor
}
